import React from "react";
import ChangeCategoryCard from "./ChangeCategoryCard";
import styles from "./diffChanges.module.scss";
const changeLine = (value) => (React.createElement("div", { key: value, className: styles["change-line"] }, value));
const TagChanges = ({ tags }) => {
    const added = tags
        .filter((change) => change.change !== "removed")
        .map((change) => changeLine(change.current));
    const removed = tags
        .filter((change) => change.change === "removed")
        .map((change) => changeLine(change.previous));
    return React.createElement(ChangeCategoryCard, { title: "Tags", added: added, removed: removed });
};
export default TagChanges;
//# sourceMappingURL=TagChanges.js.map